const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  slides: [],
  dashboardMetadata: {
    fetching: false,
    fetched: false,
    error: null
  },
  composition: {
    slidesOrder: [],
    labels: {
      fr: "",
      en: "",
      nl: ""
    },
    isPublic: false,
    isEditable: 0
  },
  error: null
};

export const dashboardCompositionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_DASHBOARD_COMPOSITION": {
      return { ...initialState };
    }
    case "SET_COMPOSITION_SLIDES_ORDER": {
      return {
        ...state,
        composition: { ...state.composition, slidesOrder: action.slidesOrder }
      };
    }
    case "SET_COMPOSITION_SLIDES": {
      return {
        ...state,
        composition: { ...state.composition, slides: action.slides }
      };
    }
    case "SET_COMPOSITION_LABEL": {
      return {
        ...state,
        composition: { ...state.composition, labels: action.labels }
      };
    }
    case "SET_COMPOSITION_IS_PUBLIC": {
      return {
        ...state,
        composition: { ...state.composition, isPublic: action.isPublic }
      };
    }
    case "SET_DASHBOARD_IS_EDITABLE": {
      return {
        ...state,
        composition: { ...state.composition, isEditable: action.isEditable }
      };
    }
    case "FETCH_SLIDES_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_SLIDES_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        slides: action.payload
      };
    }
    case "FETCH_SLIDES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        slides: [],
        error
      };
    }
    case `SAVE_DASHBOARD_COMPOSITION_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_DASHBOARD_COMPOSITION_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_DASHBOARD_COMPOSITION_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case "FETCH_DASHBOARD_METADATA_PENDING": {
      return {
        ...state,
        dashboardMetadata: {
          ...state.dashboardMetadata,
          fetched: false,
          fetching: true
        }
      };
    }
    case "FETCH_DASHBOARD_METADATA_FULFILLED": {
      return {
        ...state,
        dashboardMetadata: {
          fetching: false,
          fetched: true,
          error: null
        },
        composition: action.payload.data.data
      };
    }
    case "FETCH_DASHBOARD_METADATA_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500,
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured"
          };
      }
      return {
        ...state,
        dashboardMetadata: {
          fetching: false,
          fetched: false,
          error
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dashboardComposition.js